/* eslint-disable no-template-curly-in-string */
import React from "react"

import axios from "axios"

import Analytics from "./analytics"
import { authRequestOptions, isLoggedIn } from "./auth"

const tournamentsEndpoint = (id) =>
  `${
    process.env.GATSBY_APP_ENGINE_BASE_URL
  }/api/tournaments/${id ? id.replace("drafts.", "") : ""}`

const genericTournamentsPromise = (id, type) =>
  new Promise((resolve) => {
    axios
      .get(`${tournamentsEndpoint(id)}/${type}/`, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch(() => false)
  })

export const getTournaments = () =>
  new Promise((resolve) => {
    axios
      .get(`${tournamentsEndpoint()}`, {
        withCredentials: true,
      })
      .then((response) => resolve(response.data))
      .catch(() => false)
  })

export const getTournament = (id) =>
  new Promise((resolve) => {
    axios
      .get(`${tournamentsEndpoint(id)}/`, {
        withCredentials: true,
      })
      .then((response) => resolve(response.data))
      .catch(() => false)
  })

export const getBrackets = (id) =>
  new Promise((resolve) => {
    if (isLoggedIn()) {
      if (id) {
        getTournament(id).then((tournament) =>
          axios
            .get(
              `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/brackets/?tournament_id=${tournament.id}`,
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              resolve(response.data)
            })
            .catch(() => {
              localStorage.removeItem("isAuthenticated")
              window.location.reload()
            })
        )
      } else {
        getTournaments().then((tournaments) =>
          axios
            .get(`${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/brackets`, {
              withCredentials: true,
            })
            .then((response) => {
              const activeTournaments = response.data.filter((bracket) =>
                tournaments.find(
                  (tournament) => tournament.id === bracket.tournament_id
                )
              )
              const result = activeTournaments.map((bracket) => ({
                ...bracket,
                tournament_content_id: tournaments.find(
                  (tournament) => tournament.id === bracket.tournament_id
                ).content_id,
              }))
              resolve(result)
            })
            .catch(() => {
              localStorage.removeItem("isAuthenticated")
              window.location.reload()
            })
        )
      }
    } else resolve([])
  })

export const getBracket = (id, errorCallback) =>
  id
    ? new Promise((resolve) => {
        axios
          .get(
            `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/brackets/${id}/`,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch(() => errorCallback())
      })
    : null

export const getMatchups = (id) => genericTournamentsPromise(id, "matchups")
export const getTeams = (id) => genericTournamentsPromise(id, "teams")
export const getGroups = (id) => genericTournamentsPromise(id, "groups")
export const getRounds = (id) => genericTournamentsPromise(id, "rounds")
export const getLeaderboard = (id) =>
  genericTournamentsPromise(id, "leaderboards")

export const editBracket = (id, body, successCallback, errorCallback) =>
  axios
    .put(
      `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/brackets/${id}/`,
      body,
      authRequestOptions()
    )
    .then(() => {
      successCallback(id)
    })
    .catch((r) => errorCallback(r.response?.data.non_field_errors[0]))

export const deleteBracket = (id, successCallback, errorCallback) =>
  axios
    .delete(
      `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/brackets/${id}/`,
      authRequestOptions()
    )
    .then(() => {
      successCallback()
    })
    .catch(() => errorCallback())

export const newBracket = (body, successCallback, errorCallback) => {
  axios
    .post(
      `${process.env.GATSBY_APP_ENGINE_BASE_URL}/api/brackets/`,
      body,
      authRequestOptions()
    )
    .then((response) => {
      Analytics.triggerEvent(
        "create_bracket_success",
        {},
        "CreateBracketSuccess"
      )
      if (response.data.id) {
        editBracket(response.data.id, body, successCallback, errorCallback)
      }
    })
    .catch((r) => {
      Analytics.triggerEvent(
        "create_bracket_error",
        { error_code: r.response?.status },
        "CreateBracketError"
      )
      return errorCallback(r.response?.data.non_field_errors[0])
    })
}

export const isBracketClosed = (tournament) => {
  if (new Date(tournament?.entry_started_at) > new Date()) return "early"
  if (new Date(tournament?.entry_ended_at) < new Date()) return "late"
  return false
}

export const stringWithDates = (bracket, text) => {
  const variable = text.includes("${start_date}") ? "start_date" : "end_date"
  return text.split(`$\{${variable}}`).map((section, index) => (
    <>
      {section}
      {text.split(`$\{${variable}}`).length !== index + 1
        ? new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric",
            timeZone: process.env.GATSBY_DEFAULT_TIMEZONE,
            timeZoneName: "short",
          })?.format(new Date(`${bracket[variable]}`))
        : ""}
    </>
  ))
}
